module.exports = __webpack_public_path__ + "static/media/dau1.5cf0c7ff.jpg";